import React, { useEffect } from 'react';
import { useAuthContext } from '../contexts/Auth';
import { getUserAttributes } from '../utils';

export default function Chat() {
  const { signedIn } = useAuthContext();

  async function setUser() {
    const tawk = window['Tawk_API'];
    const user = await getUserAttributes();
    if (user && tawk?.setAttributes) {
      const email = user.email;
      const firstName = user['custom:first_name'];
      const lastName = user['custom:last_name'];
      setTimeout(() => {
        try {
          tawk.setAttributes({
            name: `${firstName} ${lastName}`,
            email: email,
          });
        } catch (error) {}
      }, 1000);
    }
  }

  useEffect(() => {
    const tawk = window['Tawk_API'];
    if (tawk?.setAttributes && signedIn) {
      setUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window['Tawk_API'], signedIn]);

  return <div id="chat" />;
}
